import React, { type MouseEvent } from 'react';
import Button from '@atlaskit/button/standard-button';
import { useIntl } from '@atlassian/jira-intl';
import { useCommonPageContext } from '@atlassian/jira-servicedesk-common-page-context/src/index.tsx';
import { useRouterPush } from '@atlassian/jira-servicedesk-customer-service-common/src/utils/use-router-push/index.tsx';
import messages from './messages.tsx';

export const CustomerNotificationHelpTextForAdminLink = () => {
	const { formatMessage } = useIntl();
	const { push } = useRouterPush();
	const { baseUrl, projectKey } = useCommonPageContext();
	const customerNotificationLink = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`;

	const onClick = (event: MouseEvent<HTMLElement>) => {
		push(event, customerNotificationLink);
	};

	return (
		<Button
			appearance="link"
			spacing="none"
			target="_blank"
			href={customerNotificationLink}
			onClick={onClick}
		>
			{formatMessage(messages.updatedNotificationsForAdminNew)}
		</Button>
	);
};

export const ViewConfigurationLink = () => {
	const { baseUrl, projectKey } = useCommonPageContext();
	const { formatMessage } = useIntl();
	return (
		<Button
			appearance="link"
			spacing="none"
			href={`${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-notifications/account-notification/invite-customer`}
		>
			{formatMessage(messages.viewConfigurationForAdmin)}
		</Button>
	);
};
